import React from 'react';
import styled from 'styled-components';
import logo from '../../resources/icons/icon-15.svg';
import { Grid } from '@mui/material';
import { SlideAbout } from './slides/SlideAbout';
import { TabletServices } from './Tablet/TabletServices';
import { Footer } from '../Footer';
import { Contact } from '../Contact';
import { SlideContent } from './parts/SlideContent';

export const LandingPageTablet = () => {
    return (
        <Container>
            <Hello>
                <HelloImage src={logo} />
            </Hello>
            <Grid container alignItems="center" justifyContent="center">
                <SlideAbout />
            </Grid>
            <Grid container>
                <TabletServices />
            </Grid>
            <SlideContent>
                <Contact />
            </SlideContent>
            <Footer />
        </Container>
    );
};

const Container = styled.div``;

const Hello = styled.div`
    height: 100vh;
    max-height: -webkit-fill-available;
    background: white;

    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    background-image: url(resources/images/Pierwszy_slajd.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const HelloImage = styled.img`
    width: 80%;
`;
